<account-menu [selectedMenu]="5" [me]="me"></account-menu>

<div class="col-lg-9 col-md-9 col-sm-8 content-panel-wrapper">

  <h2 class="page-title">Professionals</h2>

  <!-- Add Member STEP 1 -->
  <div class="col-sm-12 nopadding-mobile" *ngIf="mode == 0">
    <div class="panel">
      <div class="panel-title">Add Professionals</div>

      <div class="col-sm-12">
        <div class="panel-sub-title-alt">{{title}}</div>

        <!-- Input -->
        <div class="push-down-15">
          <div class="col-md-7 col-sm-9 col-xs-8 nopadding">
            <div class="custom-form-elem">
              <input type="text" placeholder="Professional email address" [formControl]="myForm.controls['username']"
                [(ngModel)]="newMember.username" />
            </div>
          </div>

          <!-- Enable Slider -->
          <div class="col-md-2 col-sm-3 col-xs-4 nopadding">
            <div class="enable-slider-sec">
              <div class="slider-title-small">
                Enable
              </div>
              <label class="switch">
                <input type="checkbox" [(ngModel)]="newMember.enabled">
                <span class="slider round"></span>
              </label>
              <div class="clear"></div>
            </div>
            <div class="clear"></div>
          </div>

          <div class="mobile-clear"></div>

          <!-- Button -->
          <div class="col-md-3 col-sm-12 nopadding">
            <button class="custom-form-elem-btn-alt" type="button" (click)="addMember()">Add</button>
          </div>
        </div>

        <div class="clear"></div>


        <div class="form-elem-item">
          <div class="mb-error-fail-alt"
            *ngIf="!myForm.controls['username'].valid && myForm.controls['username'].touched">
            Please enter an email
            address
          </div>
        </div>
        <div class="clear"></div>
      </div>


      <div class="clear"></div>
    </div>
  </div>

  <!-- Professionals -->
  <div class="col-sm-12 nopadding-mobile" *ngIf="mode == 0">
    <div class="panel">
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="panel-title-left">Professionals</div>
      </div>

      <div class="col-lg-6 col-md-6 col-sm-12">

        <div class="col-md-3 col-sm-3 col-xs-3 nopadding">
          <div class="enable-slider-sec">
            <div class="slider-title-small">
              Enable
            </div>
            <label class="switch">
              <input type="checkbox" [(ngModel)]="filterStatus">
              <span class="slider round"></span>
            </label>
            <div class="clear"></div>
          </div>
          <div class="clear"></div>
        </div>

        <div class="col-md-6 col-sm-6 col-xs-6 nopadding">
          <div class="custom-form-elem">
            <input type="text" placeholder="Filter" [(ngModel)]="filter" />
          </div>
        </div>

        <div class="col-md-3 col-sm-3 col-xs-3 nopadding">
          <button class="custom-form-elem-btn" type="button" (click)="filterMembers()">Find</button>
        </div>

        <div class="clear"></div>
      </div>

      <div class="clear"></div>

      <div class="col-sm-12">
        <div class="profile-sec-wrap">
          <div class="">
            <div class="col-md-6 col-sm-6 col-xs-6 mb-table-title text-left">Username</div>
            <div class="col-md-4 col-sm-4 col-xs-4 nopadding-mobile mb-table-title">Registered</div>
            <div class="col-md-2 col-sm-2 col-xs-2 nopadding-mobile mb-table-title">Status</div>

            <div class="clear"></div>

            <!-- Repeat per Prof -->
            <div class="col-sm-12 nopadding" *ngFor="let item of memberTable">
              <div class="profile-content-alt">
                <div class="col-md-6 col-sm-6 col-xs-6">
                  <div class="mb-table-lg text-left">
                    <button type="button" class="btn-table-icon" (click)="reissueJoiningCode(item)"
                      *ngIf="item.joinedOn == null">
                      <span class="glyphicon glyphicon-share-alt" aria-hidden="true"></span>
                    </button>
                    {{item.username}}
                    <br />

                    <!-- Show if joined -->
                    <span class="tag-green" *ngIf="item.joinedOn != null">(Joined)</span>
                    <!-- Show if pending -->
                    <span class="tag-red" *ngIf="item.joinedOn == null">(Pending)</span>

                  </div>
                </div>

                <div class="col-md-4 col-sm-4 col-xs-4 nopadding-mobile">
                  <div class="mb-table-lg">{{item.isRegistered}}</div>
                </div>

                <div class="col-md-2 col-sm-2 col-xs-2 nopadding-mobile">
                  <div class="mb-table-lg">
                    <!-- Rounded switch -->
                    <label class="switch">
                      <input type="checkbox" [(ngModel)]="item.enabled" (change)="toggleMemberStatus(item)">
                      <span class="slider round"></span>
                    </label>
                  </div>
                </div>

                <div class="clear"></div>
              </div>
            </div>

            <div class="clear"></div>
          </div>

          <div class="clear"></div>
        </div>

        <div class="clear"></div>
      </div>

      <div class="clear"></div>
    </div>
  </div>

  <!-- Success -->
  <div *ngIf="mode == 1">
    <div class="col-sm-12 nopadding-mobile">
      <div class="panel">
        <div class="booking-edit-image">
          <img src="/images/session-card-tick-icon.png" />
        </div>

        <div class="panel-title">Success</div>

        <div class="clear"></div>

        <div>
          <p class="profile-content">
            You have successfully added a new <br />professional to your organisation.
          </p>

          <p>
            Please instruct your professional to use the <br />below joining code during the signup process.
          </p>

          <div class="col-lg-8 col-md-8 col-sm-10 col-lg-offset-2 col-md-offset-2 col-sm-offset-1">
            <div class="profile-sec-wrap">
              <p>Joining code</p>
              <div class="profile-content-alt">
                <strong>{{issueJoiningCode.joiningCode}}</strong>
              </div>
            </div>
          </div>
        </div>

        <div class="clear"></div>

        <div class="push-down-20 push-up-10">
          <div class="col-lg-4 col-md-4 col-sm-6 col-lg-offset-4 col-md-offset-4 col-sm-offset-3">
            <button class="btn-main-proceed-alt" type="button" (click)="cancel()">Continue</button>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Failed -->
  <div *ngIf="mode == 2">
    <div class="col-sm-12 nopadding-mobile">
      <div class="panel">
        <div class="booking-edit-image">
          <img src="/images/session-card-cross-icon.png" />
        </div>

        <div class="panel-title">Error</div>

        <div class="clear"></div>

        <div>
          <p class="profile-content">
            Could not add professional,
          </p>
        </div>

        <div class="clear"></div>

        <div class="push-down-20 push-up-10">
          <div class="col-lg-4 col-md-4 col-sm-6 col-lg-offset-4 col-md-offset-4 col-sm-offset-3">
            <button class="btn-main-proceed-alt" type="button" (click)="cancel()">Continue</button>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
  </div>

</div>
